// https://github.com/diegohaz/arc/wiki/Atomic-Design#templates
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { size } from 'styled-theme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 1180px;
  box-sizing: border-box;
  @media screen and (max-width: 640px) {
    padding-top: 0rem;
  }
`;

const Header = styled.header`
`;

const Hero = styled.section``;

const Content = styled.section`
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto 2rem;
  max-width: ${size('maxWidth')};
`;

const Footer = styled.footer`
  margin-top: auto;
`;

const PageTemplate = ({ header, hero, children, footer, ...props }) => (
  <Wrapper {...props}>
    <Header>{header}</Header>
    {hero && <Hero>{hero}</Hero>}
    <Content>{children}</Content>
    <Footer>{footer}</Footer>
  </Wrapper>
  );

PageTemplate.propTypes = {
  header: PropTypes.node.isRequired,
  hero: PropTypes.node,
  footer: PropTypes.node.isRequired,
  children: PropTypes.any.isRequired,
};

export default PageTemplate;



// WEBPACK FOOTER //
// ./src/components/templates/PageTemplate/index.js